import React from 'react';

function ContactItem({ icon, title, info }) {
  return (
    <div className="text-center">
      <div className="text-5xl mb-3">{icon}</div>
      <h3 className="text-xl font-bold text-wine mb-2">{title}</h3>

      {info.map((line, index) => (
        <div 
          key={index} 
          className="text-gray-600 flex justify-center items-center gap-2"
        >
          {line}
        </div>
      ))}
    </div>
  );
}

export default ContactItem;